//src/production/components/MainProduct.jsx
import React, { useState, useEffect } from "react";
import TableTemplate from "./TableTemplate";
import AddEditMainProduct from "./AddEditMainProduct";
import { Button, Box, Drawer, Typography } from "@mui/material";
import axios from "axios";
import env from "react-dotenv";

const MainProduct = ({ onViewBOM }) => {
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`);
            setData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleAdd = () => {
        setEditData(null);
        setOpen(true);
    };

    // const handleEdit = (item) => {
    //     console.log("Editing item:", item); // Log the item being edited
    //     setEditData(item);
    //     setOpen(true);
    // };

    const handleEdit = (item) => {
        // console.log("Editing item:", item); // Log the item being edited
        // Create a new object excluding the view_bom property
        const { view_bom, ...editItem } = item; // Destructure to exclude view_bom
        setEditData(editItem); // Set editData without view_bom
        setOpen(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product/${id}`);
            setData(data.filter(item => item.id !== id));
        } catch (error) {
            console.error("Error deleting record:", error);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = async (item) => {
        try {
            if (item.id) {
                await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product/${item.id}`, item);
            } else {
                await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`, item);
            }
            fetchData();
        } catch (error) {
            console.error("Error saving record:", error);
        }
        setOpen(false);
    };

    const handleViewBOM = (productId) => {
        onViewBOM(productId); // Call the onViewBOM function passed from ProductTabs
    };

    return (
        <Box
        sx={{
            height: 670,
            width: '85%',
            marginLeft:"210px",
            marginRight:"150px",
          }}
        >
            <TableTemplate
                columns={["product_name", "view_bom", "full_name", "unit_cost", "descrip"]}
                headers={{
                    columns: ["Product", "", "Full Name", "Unit Cost", "Description"]
                }}
                iterate={data}
                data={data.map(item => ({
                    ...item,
                    view_bom: (
                        // <Box display="flex" alignItems="left" width="65%">
                        //     <Typography
                        //         component="span"
                        //         onClick={() => handleViewBOM(item.id)}
                        //         style={{
                        //             marginLeft: '0px',
                        //             color: '#4cceac',
                        //             cursor: 'pointer',
                        //             fontSize: '0.9em'
                        //         }}
                        //     >
                        //         BOM
                        //     </Typography>
                        // </Box>
                        <Button 
                        color="secondary"
                        size="small"
                        onClick={() => handleViewBOM(item.id)}
                        >
                        BOM
                        </Button>
                    )
                }))}
                onDelete={handleDelete}
                onEdit={handleEdit}
                onAdd={handleAdd}
                add
                edit
            />

            {/* Drawer for Add/Edit Form */}
            <Drawer
                anchor="right"
                open={open}
                onClose={handleClose}
                sx={{
                    "& .MuiDrawer-paper": { width: 600 }
                }}
            >
                <AddEditMainProduct onClose={handleClose} onSave={handleSave} editData={editData} />
            </Drawer>
        </Box>
    );
};

export default MainProduct;